/**
 * The extension release people can try while the Chrome Web Store reviews it.
 *
 * 0.3.0 (called 0.2.0 until 25 Oct, Jason) ships with the server while the
 * store still serves 0.1.4, so it is offered here to load by hand (Jason, 11 Oct). The zip is the store build
 * with the listing's public key as its manifest `key`, which gives an
 * unpacked install the store's extension ID, the one `VD_EXTENSION_IDS`
 * lets Connect.
 *
 * Set this to null once the store has the release. That takes down the
 * banner and the extension page's section together; delete the zip in
 * `public/` with it.
 *
 * Null since 28 Oct: the Chrome Web Store approved 0.3.0, so the store
 * listing is the way to install it. Set it again for the next release
 * offered ahead of the store.
 */
export interface ExtensionPreview {
  version: string;
  /** The zip, served from the web app's own `public/`. */
  href: string;
}

export const EXTENSION_PREVIEW: ExtensionPreview | null = null;

/**
 * Whether an installed extension is older than `version`, by its dotted
 * numbers. An unknown one counts as older: 0.1.4 never reports its version,
 * so unknown is what the store build looks like.
 */
export function isOlderExtension(installed: string | null, version: string): boolean {
  if (!installed) return true;
  const have = installed.split('.').map(Number);
  const want = version.split('.').map(Number);
  for (let index = 0; index < Math.max(have.length, want.length); index += 1) {
    const a = have[index] ?? 0;
    const b = want[index] ?? 0;
    if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
    if (a !== b) return a < b;
  }
  return false;
}
